var map = {
	".": 1227,
	"./": 1227,
	"./MentorTalk": 265,
	"./MentorTalk.jsx": 265,
	"./images/main/ExpertTalks-Nupur.png": 9050,
	"./images/main/ExpertTalks-Sanjay.png": 6618,
	"./images/main/ExpertTalks-Shreya.png": 9478,
	"./images/main/ExpertTalks-Vishal.png": 4331,
	"./images/thumbnails/ExpertTalks-Nupur.png": 2221,
	"./images/thumbnails/ExpertTalks-Sanjay.png": 5787,
	"./images/thumbnails/ExpertTalks-Shreya.png": 7826,
	"./images/thumbnails/ExpertTalks-Vishal.png": 34,
	"./index": 1227,
	"./index.jsx": 1227
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4512;